import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { QRCodeSVG } from 'qrcode.react';
import React from 'react';

interface Props {
  readonly content: string | null;
  readonly size?: number;
}

export const PIXQRCode: React.FC<Props> = (props: Props): React.ReactElement => {
  const { content, size = 140 } = props;

  if (content === null) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%">
        <CircularProgress />
      </Box>
    );
  } else {
    return <QRCodeSVG value={content} level="L" size={size} />;
  }
};
